var _rect, _g, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsMousewheel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.607,
    height: 169.1786,
    viewBox: "0 0 130.607 169.1786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.7991,
    y: 36.173,
    width: 58.2524,
    height: 97.0874,
    rx: 29.1262,
    ry: 29.1262,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.3181,
    y: 28.3396,
    width: 9.2144,
    height: 20.3333,
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.1883 28.3396 56.1623 28.3396 66.9253 12.0577 78.1883 28.3396",
    fill: "#d3343f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.5681,
    y: 79.4696,
    width: 9.2144,
    height: 20.3333,
    transform: "translate(134.3507 179.2725) rotate(-180)",
    fill: "#d3343f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.9123 99.8029 77.9383 99.8029 67.1753 116.0849 55.9123 99.8029",
    fill: "#d3343f"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.1106,
    y: 46.173,
    width: 15.6295,
    height: 35.7966,
    rx: 7.8147,
    ry: 7.8147,
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMousewheel);
export default __webpack_public_path__ + "static/media/icons_mousewheel.63e77c4bee02caf2ae3962e03e396c0a.svg";
export { ForwardRef as ReactComponent };